var map = {
	"./proyecto-InterfazReact.gif": 789,
	"./proyecto-RedSocial.gif": 351,
	"./proyecto-burgerQueenApi.gif": 391,
	"./proyecto-counter.gif": 354,
	"./proyecto-dataLovers.gif": 26,
	"./proyecto-masterTrivia.gif": 471,
	"./proyecto-mdLink.gif": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;